<template>
  <simple-slider v-bind="sliderConfig">
    <slot></slot>
  </simple-slider>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: "VerticalSlider",
        data() {
            return {
                baseConfig: {
                    controls: false,
                    nav: false,
                    axis: 'vertical',
                    preventScrollOnTouch : 'auto',
                    responsive: {
                        1024: {
                            nav: true
                        }
                    }
                }
            }
        },
        computed: {
            sliderConfig() {
                return {
                    ...this.baseConfig,
                    ...this.$attrs
                }
            }
        }
    }
</script>
